module.exports = __webpack_public_path__ + "static/media/no_activities.469df99c.png";